import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UserCreateModalUI from './UserCreateModalUI.js'

class UserCreateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // email
      email: '',
      emailError: null,
      // name
      firstName: '',
      lastName: '',
      firstNameError: null,
      lastNameError: null,
      // role
      superuserRoleId: '',
      superuserRoleList: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <UserCreateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // email
        email={this.state.email}
        onEmailChange={(event) => {this.setState({email: event.target.value})}}
        emailError={this.state.emailError}
        setEmailError={(error) => {this.setState({emailError: error})}}
        // name
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        onFirstNameChange={(event) => {this.setState({firstName: event.target.value})}}
        onLastNameChange={(event) => {this.setState({lastName: event.target.value})}}
        firstNameError={this.state.firstNameError}
        lastNameError={this.state.lastNameError}
        setFirstNameError={(error) => {this.setState({firstNameError: error})}}
        setLastNameError={(error) => {this.setState({lastNameError: error})}}
        // superuser role
        superuserRoleId={this.state.superuserRoleId}
        superuserRoleList={this.state.superuserRoleList}
        onSuperuserRoleIdChange={(event) => {this.setState({superuserRoleId: event.target.value})}}
        // modes
        createMode={this.props.createMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getSuperuserRoles(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.post(this.props.context,
      `/api/su/superusers`,
      this.onSubmitCallback, {
        email: this.state.email,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        superuserRoleId: this.state.superuserRoleId,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'email':
          this.setState({emailError: error.message})
          break;
        case 'firstName':
          this.setState({firstNameError: error.message})
          break;
        case 'lastName':
          this.setState({lastNameError: error.message})
          break;
        default:
      }
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    if (this.state.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          email: '',
          firstName: '',
          lastName: '',
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getSuperuserRoles(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/roles/superuser`,
      cacheKey: CacheKeys.Roles('superuser', context.locale),
      callback: this.getSuperuserRolesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {locales: context.locale})
  }

  getSuperuserRolesCallback = (response) => {
    let nonOwnerRoleList = response.roleList.map(role => ({key: role.roleId, value: role.roleName}))
    this.setState({
      superuserRoleList: nonOwnerRoleList,
      superuserRoleId: nonOwnerRoleList[1].key
    })
  }

}

export default withRouter(UserCreateModalSF)
